import { render, staticRenderFns } from "./SessionListLoader.vue?vue&type=template&id=4221b609&"
import script from "./SessionListLoader.vue?vue&type=script&lang=js&"
export * from "./SessionListLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports